module.exports = __webpack_public_path__ + "img/control_box.dd557b3a.png";